import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class AcompanhamentoProvider {
  baseUrl = environment.API_URL;
  constructor(public http: HttpClient) {}

  tratarConteudo(acompanhamento, participanteList, responsavelList) {
    var parts = [];
    participanteList.forEach((part) => {
      parts.push(part.id);
    });

    var resps = [];
    responsavelList.forEach((resp) => {
      resps.push(resp.id);
    });

    var acomp: any = {};
    acomp.acompanhamento = acompanhamento.descricao;
    acomp.titulo = acompanhamento.titulo;
    acomp.restrito = acompanhamento.restrito;
    acomp.datahora = acompanhamento.dataHora_data + ' ' + acompanhamento.dataHora_hora + ':00';
    acomp.dataHoraFim = acompanhamento.dataHoraFim_data + ' ' + acompanhamento.dataHoraFim_hora + ':00';
    acomp.idAcompanhamentoOperacao = acompanhamento.idAcompanhamentoOperacao;
    acomp.idAcompanhamentoStatus = acompanhamento.idAcompanhamentoStatus;
    acomp.idAcompanhamentoPai = acompanhamento.idAcompanhamentoPai ? acompanhamento.idAcompanhamentoPai : null;

    return {
      participantes: parts,
      responsaveis: resps,
      acompanhamento: acomp,
    };
  }

  getAcompanhamentos(filtro) {
    filtro.idAcompanhamentoOperacao = filtro.idAcompanhamentoOperacao == '0' ? null : filtro.idAcompanhamentoOperacao;
    filtro.idCategoria = filtro.idCategoria == '0' ? null : filtro.idCategoria;
    filtro.tipo = filtro.tipo == '0' ? null : filtro.tipo;
    return this.http
      .post<any>(this.baseUrl + '/acompanhamento/get-acompanhamentos', {
        filtro: filtro,
      })
      .map((data) => {
        return data;
      });
  }

  getHistorico(filtro) {
    return this.http
      .get<any>(this.baseUrl + '/acompanhamento/get-historico-pessoa', {
        params: {
          dataInicio: filtro.dataInicio,
          dataFim: filtro.dataFim,
          filtro: filtro.filtroResponsavel,
        },
      })
      .map((data) => {
        return data;
      });
  }

  getHistoricoByIdPessoa(idPessoa) {
    return this.http
      .post<any>(this.baseUrl + '/acompanhamento/get-acompanhamentos-by-id-pessoa', { idPessoa: idPessoa })
      .map((data) => {
        return data;
      });
  }

  getDadosBasicos() {
    return this.http.get<any>(this.baseUrl + '/acompanhamento/get-dados-basicos').map((data) => {
      return data;
    });
  }

  getStatusFinalizar() {
    return this.http.get<any>(this.baseUrl + '/acompanhamento/get-status-finalizar').map((data) => {
      return data;
    });
  }

  getStatusReagendar() {
    return this.http.get<any>(this.baseUrl + '/acompanhamento/get-status-reagendar').map((data) => {
      return data;
    });
  }

  validarHorarioResponsavel(dadosValidacao) {
    return this.http
      .post<any>(this.baseUrl + '/acompanhamento/validar-horario-responsavel', dadosValidacao)
      .map((data) => {
        return data;
      });
  }

  salvarAcompanhamento(acompanhamento, participantes, responsaveis) {
    return this.http
      .post<any>(this.baseUrl + '/acompanhamento/salvar-acompanhamento', {
        acompanhamento: acompanhamento,
        participantes: participantes,
        responsaveis: responsaveis,
      })
      .map((data) => {
        return data;
      });
  }

  salvarAcompanhamentoDetalhes(acompanhamento) {
    return this.http
      .post<any>(this.baseUrl + '/acompanhamento/salvar-acompanhamento-detalhes', { acompanhamento: acompanhamento })
      .map((data) => {
        return data;
      });
  }

  salvarCompromissoDetalhes(acompanhamento) {
    return this.http
      .post<any>(this.baseUrl + '/acompanhamento/salvar-compromisso-detalhes', {
        acompanhamento: acompanhamento,
      })
      .map((data) => {
        return data;
      });
  }

  salvarPessoa(idAcompanhamento, pessoas, isResponsavel) {
    return this.http
      .post<any>(this.baseUrl + '/acompanhamento/salvar-pessoas-acompanhamento', {
        idAcompanhamento: idAcompanhamento,
        pessoas: pessoas,
        isResponsavel: isResponsavel,
      })
      .map((data) => {
        return data;
      });
  }

  finalizarAcompanhamento(idAcompanhamento, idAcompanhamentoStatus, descricao) {
    return this.http
      .post<any>(this.baseUrl + '/acompanhamento/finalizar-acompanhamento', {
        idAcompanhamento: idAcompanhamento,
        idAcompanhamentoStatus: idAcompanhamentoStatus,
        descricao: descricao,
      })
      .map((data) => {
        return data;
      });
  }

  assumir(idAcompanhamento) {
    return this.http
      .post<any>(this.baseUrl + '/acompanhamento/assumir-acompanhamento', {
        idAcompanhamento: idAcompanhamento,
      })
      .map((data) => {
        return data;
      });
  }

  reagendarAcompanhamento(acompanhamento) {
    return this.http
      .post<any>(this.baseUrl + '/acompanhamento/reagendar-acompanhamento', {
        acompanhamento: acompanhamento,
      })
      .map((data) => {
        return data;
      });
  }

  acompanhamentosFilhos(filtro) {
    return this.http
      .post<any>(this.baseUrl + '/acompanhamento/acompanhamentos-filhos', {
        filtro: filtro,
      })
      .map((data) => {
        return data;
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/acompanhamento/acompanhamento.ts